export const small = [
  {
    type: "Feature",
    properties: { featureIndex: 0, distanceToPoint: 5.01703666187278 },
    geometry: {
      type: "Point",
      coordinates: [
        -90.0715323,
        29.95106579999999,
        { city: "New Orleans", state: "Louisiana" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 1, distanceToPoint: 9.713059372006162 },
    geometry: {
      type: "Point",
      coordinates: [
        -81.7786972,
        26.339806,
        { city: "Bonita Springs", state: "Florida" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 2, distanceToPoint: 12.042511240664115 },
    geometry: {
      type: "Point",
      coordinates: [
        -86.5673,
        34.7269,
        { city: "Huntsville", state: "Alabama" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 2, distanceToPoint: 12.042511240664115 },
    geometry: {
      type: "Point",
      coordinates: [
        -86.80248999999999,
        33.5206608,
        { city: "Birmingham", state: "Alabama" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 3, distanceToPoint: 1.4867766084901781 },
    geometry: {
      type: "Point",
      coordinates: [
        -80.8854,
        35.787593,
        { city: "Statesville", state: "North Carolina" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 4, distanceToPoint: 2.6571740285652634 },
    geometry: {
      type: "Point",
      coordinates: [
        -84.5120196,
        39.1031182,
        { city: "Cincinnati", state: "Ohio" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 6, distanceToPoint: 0.47216290435729025 },
    geometry: {
      type: "Point",
      coordinates: [
        -81.723774,
        33.555178,
        { city: "Aiken", state: "South Carolina" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 6, distanceToPoint: 0.47216290435729025 },
    geometry: {
      type: "Point",
      coordinates: [
        -85.6768,
        38.189,
        { city: "Louisville", state: "Kentucky" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 7, distanceToPoint: 4.902446250459124 },
    geometry: {
      type: "Point",
      coordinates: [
        -93.29229889999999,
        37.2089572,
        { city: "Springfield", state: "Missouri" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 7, distanceToPoint: 4.902446250459124 },
    geometry: {
      type: "Point",
      coordinates: [-95.0998, 29.5716, { city: "League City", state: "Texas" }],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 7, distanceToPoint: 4.902446250459124 },
    geometry: {
      type: "Point",
      coordinates: [
        -93.29229889999999,
        37.2089572,
        { city: "Springfield", state: "Missouri" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 8, distanceToPoint: 2.908327798841014 },
    geometry: {
      type: "Point",
      coordinates: [
        -89.6501481,
        39.78172130000001,
        { city: "Springfield", state: "Illinois" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 8, distanceToPoint: 2.908327798841014 },
    geometry: {
      type: "Point",
      coordinates: [
        -86.7852,
        36.1866,
        { city: "Nashville", state: "Tennessee" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 9, distanceToPoint: 42.16861144204986 },
    geometry: {
      type: "Point",
      coordinates: [
        -77.3663538,
        35.612661,
        { city: "Greenville", state: "North Carolina" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 11, distanceToPoint: 5.011472904806767 },
    geometry: {
      type: "Point",
      coordinates: [
        -149.9002778,
        61.2180556,
        { city: "Anchorage", state: "Alaska" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 11, distanceToPoint: 5.011472904806767 },
    geometry: {
      type: "Point",
      coordinates: [-95.2499, 38.959, { city: "Lawrence", state: "Kansas" }],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 12, distanceToPoint: 1.0944571886638628 },
    geometry: {
      type: "Point",
      coordinates: [
        -88.2433829,
        40.1164204,
        { city: "Champaign", state: "Illinois" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 13, distanceToPoint: 6.935081281864724 },
    geometry: {
      type: "Point",
      coordinates: [
        -82.3940104,
        34.85261759999999,
        { city: "Greenville", state: "South Carolina" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 14, distanceToPoint: 7.291814201806812 },
    geometry: {
      type: "Point",
      coordinates: [
        -72.290014,
        43.701767,
        { city: "Hanover", state: "New Hampshire" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 16, distanceToPoint: 1.1617691674084085 },
    geometry: {
      type: "Point",
      coordinates: [
        -117.4260466,
        47.6587802,
        { city: "Spokane", state: "Washington" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 17, distanceToPoint: 6.735585054501796 },
    geometry: {
      type: "Point",
      coordinates: [
        -77.6109219,
        43.16103,
        { city: "Rochester", state: "New York" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 19, distanceToPoint: 13.094005020260555 },
    geometry: {
      type: "Point",
      coordinates: [
        -82.4571776,
        27.950575,
        { city: "Tampa", state: "Florida" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 20, distanceToPoint: 5.055371102178251 },
    geometry: {
      type: "Point",
      coordinates: [
        -80.0649,
        40.612,
        { city: "Wexford", state: "Pennsylvania" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 21, distanceToPoint: 7.388684520795382 },
    geometry: {
      type: "Point",
      coordinates: [
        -81.162316,
        36.141082,
        { city: "Wilkesboro", state: "North Carolina" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 21, distanceToPoint: 7.388684520795382 },
    geometry: {
      type: "Point",
      coordinates: [
        -80.2228,
        36.1024,
        { city: "Winston Salem", state: "North Carolina" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 23, distanceToPoint: 8.176812718806344 },
    geometry: {
      type: "Point",
      coordinates: [
        -92.1004852,
        46.78667189999999,
        { city: "Duluth", state: "Minnesota" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 25, distanceToPoint: 1.5765834408358372 },
    geometry: {
      type: "Point",
      coordinates: [-84.1916069, 39.7589478, { city: "Dayton", state: "Ohio" }],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 26, distanceToPoint: 1.652251640402955 },
    geometry: {
      type: "Point",
      coordinates: [
        -91.5301683,
        41.6611277,
        { city: "Iowa City", state: "Iowa" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 26, distanceToPoint: 1.652251640402955 },
    geometry: {
      type: "Point",
      coordinates: [
        -86.53527875136474,
        39.16030011161718,
        { city: "Bloomington", state: "Indiana" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 26, distanceToPoint: 1.652251640402955 },
    geometry: {
      type: "Point",
      coordinates: [
        -83.73833881075346, 42.25371166737298,
        { city: "Ann Arbor", state: "Michigan" },
      ],
    },
  },
  {
    type: "Feature",
    properties: { featureIndex: 26, distanceToPoint: 1.652251640402955 },
    geometry: {
      type: "Point",
      coordinates: [
        -93.76568218476974, 32.471630703081026,
        { city: "Shreveport", state: "Louisana" },
      ],
    },
  },
];
